import apiClient from './client';

export interface Job {
  pk: string;
  sk: string;
  type: string;
  instanceId: string;
  instanceName?: string; // Friendly name for display
  region: string;
  action: 'start' | 'stop';
  schedule: {
    daysOfWeek: number[];
    hour: number;
    minute: number;
  };
  enabled: boolean;
  description?: string;
  instanceType?: string;
  createdAt: string;
  lastExecutionTime?: string | null; // ISO timestamp of last execution
}

export interface CreateJobRequest {
  instanceId: string;
  instanceName?: string; // Optional friendly name
  region: string;
  action: 'start' | 'stop';
  schedule: {
    daysOfWeek: number[];
    hour: number;
    minute: number;
  };
  description?: string;
  instanceType?: string;
  enabled?: boolean;
}

export const jobsApi = {
  // Get all jobs
  getAll: async (): Promise<Job[]> => {
    const response = await apiClient.get<Job[]>('/jobs');
    return response.data;
  },

  // Create a new job
  create: async (job: CreateJobRequest): Promise<void> => {
    const newJob: Job = {
      pk: 'JOB',
      sk: `SCHEDULE_${Date.now()}`,
      type: 'schedule',
      ...job,
      enabled: job.enabled ?? false,
      createdAt: new Date().toISOString(),
    };
    await apiClient.post('/jobs', newJob);
  },

  // Update a job
  update: async (sk: string, job: Partial<Job>): Promise<void> => {
    await apiClient.put(`/jobs/${encodeURIComponent(sk)}`, job);
  },

  // Delete a job
  delete: async (sk: string): Promise<void> => {
    await apiClient.delete(`/jobs/${encodeURIComponent(sk)}`);
  },

  // Toggle job enabled/disabled
  toggle: async (sk: string): Promise<void> => {
    await apiClient.post(`/jobs/${encodeURIComponent(sk)}/toggle`);
  },

  // Run a job immediately
  runNow: async (sk: string): Promise<void> => {
    await apiClient.post(`/jobs/${encodeURIComponent(sk)}/run`);
  },
};
